/**
 * عنوان Hub لوحة التحكم — نفس أصل الـ API لكن بدون لاحقة /api
 * مثال: http://localhost:8080/wakeel/api → http://localhost:8080/wakeel/hubs/dashboard
 */
export function resolveDashboardHubUrl(apiBaseURL: string): string {
  const trimmed = apiBaseURL.trim().replace(/\/+$/, '');
  const root = trimmed.endsWith('/api') ? trimmed.slice(0, -4) : trimmed;
  return `${root}/hubs/dashboard`;
}
